import { api_GET, api_PUT } from "../api/_axios.js";

const prazoresponsividade_api =
{
    getAll: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`PrazoResponsividade`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_PUT(`PrazoResponsividade`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default prazoresponsividade_api
